var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"id":"path1450","d":"M 8.5 0 L 8.5 8.5 L 0 8.5 L 0 9.5 L 8.5 9.5 L 8.5 18 L 9.5 18 L 9.5 9.5 L 18 9.5 L 18 8.5 L 9.5 8.5 L 9.5 0 L 8.5 0 z "}})}
var staticRenderFns = []

export { render, staticRenderFns }